export default {
    name: 'UpdateNotification',
    setup(_, { emit }) {
        const refresh = () => {
            emit('refresh');
        };
        return {
            refresh
        };
    }
};
